import React, { Suspense, useEffect, useState } from 'react'
import client from '../API/API';
import { Box, Card, Container, Grid, SimpleGrid, Text } from '@mantine/core';
import ManualsandDocsCard from '../components/cards/ManualsandDocsCard';
import TableTechnicalDetails from '../components/Machines/Technical_Details';
import { BiDownload, BiSolidFileDoc } from 'react-icons/bi';
import LoaderComponent from '../components/loader/LoaderComponent';
import { formatString, } from '../utils/reusedfunctions';

import NoDataAvailable from '../components/noDataAvailable/NoDataAvailable';

const DetailsMachines = (props) =>
{

    const { nodeid } = props
    const [machineData, setMachineData] = useState({});


    // console.log(machineData)
    // formatString()

    // useEffect(() =>
    // {
    //     setMachineData({})
    //     if (nodeid !== "")
    //     {

    //         const generalDetails = () =>
    //         {

    //             client.get("/Machines_sub_details/", {
    //                 params: {
    //                     node_id: nodeid,
    //                     // module: "Details"
    //                     module: "5"
    //                 },
    //                 withCredentials: true
    //             }).then((resp) => (

    //                 setMachineData(resp.data)


    //             )).catch((error) => console.log("error", error))
    //         }
    //         generalDetails()
    //     }

    // }, [nodeid])
    return (

        <Container fluid p={0} pb={16}>

            {/* Details Card */}



            {Object.entries(machineData).length > 0 ?


                <Grid>
                    {Object.entries(machineData).map(([key, value]) =>
                    {

                        if (key === "general_details")
                        {
                            return <Grid.Col span={4}> <Card

                                shadow="sm"
                                padding="xl"
                                component="a"
                                className='subCard' style={{ height: '17rem' }}>
                                <Text size="md" className='subcardHeading' style={{ marginBottom: '0.5rem', maxHeight: '300px' }}>
                                    Details
                                </Text>
                                {Object.entries(value).map(([key, value]) =>
                                    <SimpleGrid cols={2}>
                                        <Text color='var(--color-text)' weight={400} className='detailsCardcol1' >
                                            {formatString(key)}
                                        </Text>
                                        <Text className='detailsCardcol2' color='var(--color-bold-text)' weight={500} >
                                            {value}
                                        </Text>



                                    </SimpleGrid>
                                )}
                            </Card>
                            </Grid.Col>
                        }

                        if (key === "Manuals_and_Docs" && value.length > 0)
                        {
                            return <Grid.Col span={8}> <Card

                                shadow="sm"
                                padding="xl"
                                component="a"
                                className='subCard' style={{ height: '17rem' }}
                            >
                                <Text style={{ marginBottom: '0.5rem' }} className='subcardHeading'>
                                    Manuals & Docs
                                </Text>
                                {value.map((cell) =>
                                    <SimpleGrid cols={3}>
                                        <Box mt={23} ml={24} style={{ display: 'flex', flexDirection: 'column' }}>

                                            <BiSolidFileDoc size={32} />
                                        </Box>
                                        {/* {
            "Filename": "Electrical Drawing",
            "FileUrl": "https://chat.openai.com/"
        }
    ],
    "Techincal_Details_data": [
        {
            "Item_Name": "PLC",
            "Manufacture_Name": "Delta",
            "Manufacture_Model_No": "S12",
            "Expiry_Date": "2024-04-25"
        } */}
                                        <Box mt={16} style={{ display: 'flex', flexDirection: 'column' }}>

                                            <Text size={14} w={500}>{cell.Filename}</Text>
                                            <label style={{ fontSize: '12px' }} >Owner</label>
                                        </Box>
                                        {/* <Box style={{ display: 'flex', flexDirection: 'column' }}>

                                            <Text>Created</Text>
                                            <label >Date :</label>
                                        </Box> */}
                                        <Box style={{ textAlign: 'center', fontSize: '2rem' }}>

                                            <a href={cell.FileUrl} download>
                                                <BiDownload />
                                            </a>

                                        </Box>
                                    </SimpleGrid>
                                )}
                            </Card>
                            </Grid.Col>
                        }
                        if (key === "Techincal_Details_data" && value.length > 0)
                        {
                            return <Grid.Col> <Card
                                shadow="sm"
                                component="a"
                                // height:22.2rem
                                className='subCard' style={{ height: 'inherit', padding: '0rem', backgroundColor: 'transparent' }}>

                                <TableTechnicalDetails data={value} />

                            </Card>
                            </Grid.Col>

                        }

                    }
                    )}
                </Grid>

                : <LoaderComponent />

            }








        </Container>


    )
}

export default DetailsMachines
